import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api';

const UserActivities = () => {
  const [userActivities, setUserActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUserActivities = async () => {
      try {
        setLoading(true);
        
        const response = await apiService.getUserActivities();
        
        setUserActivities(response.data);
      } catch (err) {
        setError('获取报名记录失败');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserActivities();
  }, []);

  const getStatusBadge = (status) => {
    switch (status) {
      case 'registered':
        return <span className="badge bg-warning">已报名</span>;
      case 'attended':
        return <span className="badge bg-info">已参加</span>;
      case 'completed':
        return <span className="badge bg-success">已完成</span>;
      case 'deleted':
        return <span className="badge bg-danger">已取消</span>;
      default:
        return <span className="badge bg-secondary">未知</span>;
    }
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">加载中...</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="mb-4">我的活动报名</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      
      {userActivities.length === 0 ? (
        <div className="alert alert-info">您还没有报名任何活动</div>
      ) : (
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>活动名称</th>
                    <th>积分</th>
                    <th>状态</th>
                    <th>报名时间</th>
                    <th>活动时间</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {userActivities.map(ua => (
                    <tr key={ua.id}>
                      <td>{ua.activity?.name}</td>
                      <td>
                        <span className="badge bg-info">{ua.activity?.points}</span>
                      </td>
                      <td>{getStatusBadge(ua.status)}</td>
                      <td>{new Date(ua.registered_at).toLocaleString()}</td>
                      <td>
                        {ua.activity && (
                          <>
                            <small>开始: {new Date(ua.activity.start_time).toLocaleString()}</small><br />
                            <small>结束: {new Date(ua.activity.end_time).toLocaleString()}</small>
                          </>
                        )}
                      </td>
                      <td>
                        <Link to={`/activities/${ua.activity_id}`} className="btn btn-sm btn-outline-primary">
                          查看详情
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserActivities;
